module.exports = __webpack_public_path__ + "portal/assets/img/logo.8d9cf904.svg";